export default __webpack_public_path__ + "static/media/pm-22.0210decf.svg";